<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>BLUE YODEL 10</span></p>
<p class="chap-subtitle1"><span>ROD</span></p>
<p class="indent"><i>Marisa rejects being expected to “do for” men. So she does for plants</i>.</p>
<p class="indent"><i>We have eighty-four plants. Marisa talks to them, and they nod…</i>.</p>
<p class="indent"><i>We have the only apartment I know of that has to be raked</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter19.vue?754ae729